"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8390],{

/***/ 4253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(512);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/styled-engine/index.js + 4 modules
var styled_engine = __webpack_require__(742);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(8784);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(7893);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(1713);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/createBox.js
'use client';



const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0,styled_engine["default"])('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx/* default */.Z);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);
    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(8356);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(8239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(606);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(5154);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/boxClasses.js

const boxClasses = (0,generateUtilityClasses/* default */.Z)('MuiBox', ['root']);
/* harmony default export */ var Box_boxClasses = (boxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js
'use client';







const defaultTheme = (0,createTheme/* default */.Z)();
const Box = createBox({
  themeId: identifier/* default */.Z,
  defaultTheme,
  defaultClassName: Box_boxClasses.root,
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 8390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AppPopup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/assets/images/whiteCross.webp
/* harmony default export */ var whiteCross = ({"src":"/_next/static/media/whiteCross.93ac355c.webp","height":1024,"width":1024,"blurDataURL":"data:image/webp;base64,UklGRpQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSCkAAAABJ0AmbdMK6PwfEx4RwewwCDDNHsERgsggf6okIvo/AayMU9EwTsU9CwBWUDggRAAAAHACAJ0BKggACAACQDglpAAPgEmAfoAfVHYg2WAA/uzborHmMGHffaONhiDoGnRnTX+at5QVLbM5ltWSpG47pRnEMAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/powerofFive.webp
/* harmony default export */ var powerofFive = ({"src":"/_next/static/media/powerofFive.bc867cb7.webp","height":1080,"width":1080,"blurDataURL":"data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAAAwAgCdASoIAAgAAkA4JbACdLoAAzuX5NtSQAD++gxTul2ZrZurwq7fP2QQ82OdH/ePI7ox9EOtf/Iuvh+HBXUcAAA=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./utils/Utils.ts
var Utils = __webpack_require__(2619);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/AppPopup.tsx








function AppPopup() {
    const router = (0,next_router.useRouter)();
    const [showPopup, setShowPopup] = (0,react.useState)(false);
    const handlePopupClose = ()=>{
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };
    const handlePopupOpen = ()=>{
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };
    const openCTA = ()=>{
        window.open("https://gromo.co.in/PbcK", "_blank");
    };
    (0,react.useEffect)(()=>{
        if (router.pathname === "/customer") {
            return;
        }
        if (Utils/* default.getCookie */.Z.getCookie("AppPopup") || (router === null || router === void 0 ? void 0 : router.query["app-status"])) {} else {
        // Utils.setCookies("AppPopup", "true", 3);
        // setTimeout(() => {
        //   handlePopupOpen();
        // }, 5000);
        // setTimeout(() => {
        //   handlePopupClose();
        // }, 15000);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showPopup && router.pathname !== "/customer" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                id: "AppPopup",
                sx: {
                    height: "100%",
                    width: "100%",
                    display: "grid",
                    placeContent: "center",
                    background: "#10101266",
                    inset: 0,
                    zIndex: 55,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        position: "relative",
                        width: {
                            xs: "90%",
                            md: "60%"
                        },
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: {
                                    xs: "300px",
                                    md: "400px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: whiteCross,
                                alt: "cross grey",
                                height: 32,
                                width: 32,
                                onClick: handlePopupClose,
                                style: {
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "12px",
                                    right: "12px"
                                },
                                loading: "lazy"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 1000,
                            height: 1000,
                            src: powerofFive,
                            onClick: openCTA,
                            alt: "Power of Five",
                            style: {
                                cursor: "pointer",
                                // width: "100%",
                                borderRadius: "16px"
                            },
                            loading: "lazy"
                        })
                    ]
                })
            })
        }) : null
    });
}
/* harmony default export */ var components_AppPopup = (AppPopup);


/***/ }),

/***/ 2619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _class; }
/* harmony export */ });
class _class {
    static getOS() {
        var uA = navigator.userAgent || navigator.vendor;
        if (uA.includes("Mac") && "ontouchend" in document) return "iOS";
        var i, os = [
            "Windows",
            "Android",
            "Unix",
            "Mac",
            "Linux",
            "BlackBerry"
        ];
        for(i = 0; i < os.length; i++)if (new RegExp(os[i], "i").test(uA)) return os[i];
    }
    static setTitle(title) {
        document.title = title;
    }
    static trackEvent(event, data) {
        try {
            const Moengage = window === null || window === void 0 ? void 0 : window.moe({
                app_id: "MALTTXFD391QLJ3UZNAD1ZH9",
                debug_logs: Number(0)
            });
            if (data && Object.keys(data).length) {
                Moengage.track_event(event, data);
                console.log("data", data);
            } else {
                Moengage.track_event(event);
            }
        } catch (error) {}
    }
    static setCookies(name, value, hours) {
        var expires = "";
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        globalThis.window.document.cookie = name + "=" + (value || "") + expires + "; path=/; Secure";
    }
    static getCookie(name) {
        var ref, ref1, ref2;
        var nameEQ = name + "=";
        var ca = globalThis === null || globalThis === void 0 ? void 0 : (ref = globalThis.window) === null || ref === void 0 ? void 0 : (ref1 = ref.document) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cookie) === null || ref2 === void 0 ? void 0 : ref2.split(";");
        for(var i = 0; i < (ca === null || ca === void 0 ? void 0 : ca.length); i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    static removeCookie(name) {
        globalThis.window.document.cookie = name + "=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
}



/***/ })

}]);